import { Inject, Component } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { LazyLoadingService } from 'src/app/services/lazy-loading.service';
import { PwAlertDialogComponent } from 'src/app/ui-test/pw-alert-dialog/pw-alert-dialog.component';
import { AndroidBillService, BillService, IOSBillService, PlanName } from 'src/app/services/bill.service';
import { App, AppService } from 'src/app/services/app.service';
import { MessageCheckTokenHasExpired, MessageCognitoInit, MessageCordovaAndroidStore, MessageCordovaAppStore, MessageCordovaIAPProcessing, MessageCordovaRestore, MessageLicenseAndCardUpdated, MessageRestoreLicense, MessageService } from 'src/app/services/message.service';
import { CompareComponent } from 'src/app/ui-test/pw-payment/pw-payment.component';
import { environment } from 'src/environments/environment';
import { forEach } from 'xregexp';
// import { SettingsService } from 'src/app/services/settings.service';

// The upgrade-plan dialog pop up served
export interface UpgradeData {
    isAutoRenew: boolean;
    isMonthly: boolean;
    liccode: string;
    email: string;
    userPlan: PlanName;
    isUpgrade: boolean;
}

@Component({
    selector: 'app-dialog-upgrade',
    templateUrl: './dialog-upgrade.component.html',
    styleUrls: ['./dialog-upgrade.component.scss']
})
export class DialogUpgradeComponent {
    plan = { plan: '', price: '' };
    prorate = 'Calculating...';
    liccode = '';
    email = '';
    // upgradeData = null;
    appName = AppService.appName;
    app = App;
    isAppPaid = false;
    paidType = 'prem_monthly';
    // premPaid = false;
    // plusPaid = false;

    userPlan = PlanName.freePlan;
    freePlan = PlanName.freePlan;
    premPlan = PlanName.premPlan;
    plusPlan = PlanName.plusPlan;

    nextPaymentDate = '';
    // nowDate = '-';
    planName = '';
    isUpgrade = true;
    dialogTitle = 'Upgrade';
    isMonthly: boolean = false;
    selectedPlan = 'Yearly';
    monthlyValue = 'Monthly';
    yearlyValue = 'Yearly';

    private isWaitingForLicense = true;

    showLoad = false;
    finishPurchases = false;

    subscription;

    /* add for new payment UI */
    isBestPlan: boolean = true;
    backdropOpen: boolean = true;
    cardTimer = null;

    checked = true;
    processing = '';
    isUpgradingOnStripe: boolean = false;
    /* add for new payment UI */

    choosePlan = null;
    bestPlus = {
        month: 9.17,
        year: 110,
        payText: '110.00',
        discount: '57%',
        lic: '6008',
        price: 110,
        plan: 'Personal Plus Yearly',
        planId: 'Personal_Plus_Yearly'
      };
      bestPremium = {
        month: 4.99,
        year: 59.88,
        payText: '59.88',
        discount: '50%',
        lic: '6006',
        price: 59.88,
        plan: 'Personal Premium Yearly',
        planId: 'Personal-premium'
      };
      flexPlus = {
        month: 19.00,
        payText: '19.00',
        lic: '6005',
        price: 19.00,
        plan: 'Personal Plus Monthly',
        planId: 'Personal_Plus_Monthly'
      };
      flexPremium = {
        month: 9.99,
        payText: '9.99',
        lic: '6001',
        price: 9.99,
        plan: 'Personal Premium Monthly',
        planId: 'personal-monthly'
      };

    plusYearlyPrice = {
        price: '$119',
        priceMicros: 119000000,
        averagePrice: 9.92,
        currency: 'USD'
    };
    plusMonthlyPrice = {
        price: '$20.90',
        priceMicros: 20900000,
        averagePrice: 20.90,
        currency: 'USD'
    };

    constructor(
        public dialogRef: MatDialogRef<DialogUpgradeComponent>,
        public billService: BillService,
        public dialog: MatDialog,
        private messageService: MessageService,
        public snackBar: MatSnackBar,
        private lazyLoadingService: LazyLoadingService,
        // private settingsService: SettingsService,
        @Inject(MAT_DIALOG_DATA) public data: UpgradeData) {
        // this.upgradeData = data;
        console.log('upgrade data', data);

        if (data.isMonthly) {
            this.plan = { plan: 'Monthly', price: '$20.90 USD/Month' };
        } else {
            this.plan = { plan: 'Yearly', price: '$119.00 USD/Year' };
        }
        this.liccode = data.liccode;
        this.email = data.email;

        if (this.email === undefined || typeof (this.email) === 'undefined') {
            this.email = '';
        }
        this.subscription = this.messageService.getMessage().subscribe(async (message) => {
            // if (message.name === MessageRefreshLicenseAndCard) {
            //     if (message.data.action === 'receive') {
            //         let licenseAndCard = message.data.res;
            //         console.log('getLicenseAndCard: ', licenseAndCard);
            //         this.nextPaymentDate = licenseAndCard.license.expiryDate;
            //         this.isAppPaid = true;
            //         this.snackBar.dismiss();
            //         this.hideLoading();
            //         // sendMessage MessageLicenseAndCardUpdated in userService
            //     }
            // }
            if (message.name === MessageLicenseAndCardUpdated) {
                if (this.planName === '') {
                    this.isAppPaid = false;
                } else {
                    if (this.isWaitingForLicense) {
                        this.isWaitingForLicense = false;
                        const licenseAndCard = message.data;
                        console.log('getLicenseAndCard: ', licenseAndCard);
                        this.nextPaymentDate = licenseAndCard.license.expiryDate;
                        if (this.nextPaymentDate === 'expired') {
                            this.isAppPaid = false;
                        } else {
                            this.isAppPaid = true;
                        }
                        this.snackBar.dismiss();
                        this.hideLoading();
                    }
                }
            } else if (message.name === MessageCordovaAndroidStore) {
                // let store = (<any>window).inAppPurchase;
                if (message.data != null) {
                    if (message.data.rst == 'finish') {
                        // let p = message.data.p;
                        let transaction = message.data.transaction;
                        // if (p) {
                        //     this.planName = p.alias;
                        if (transaction) {
                            this.planName = transaction.nativePurchase.productId;
                            if (!this.checkLicenseMatchAndroidTransaction(this.planName)) {
                                //p.id p.transaction.purchaseToken
                                this.isWaitingForLicense = true;
                                this.finishPurchases = true;
                                this.snackBar.open('Updating your license, please wait.', 'OK', { verticalPosition: 'bottom' });
                                // (<AndroidBillService>this.billService).saveReceiptInDdb(p.id, p.transaction.purchaseToken).then(res => {
                                (<AndroidBillService>this.billService).saveReceiptInDdb(transaction.nativePurchase.productId, transaction.nativePurchase.purchaseToken).then(res => {
                                    this.messageService.sendMessage({ name: MessageCognitoInit });
                                });
                            }
                        } else {
                            this.hideLoading();
                        }
                    } else if (message.data.rst == 'error' || message.data.rst == 'cancel' || message.data.rst == 'refunded') {
                        this.hideLoading();
                    }
                    // else if (message.data.rst == 'owned') {
                    //     let productId = message.data.productId;
                    //     if (productId == 'prem_monthly' || productId == 'prem_yearly') {
                    //         this.premPaid = true;
                    //     }
                    //     if (productId == 'plus_monthly' || productId == 'plus_yearly') {
                    //         this.plusPaid = true;
                    //     }
                    // }
                }
            } else if (message.name === MessageCordovaAppStore) {
                if (message.data != null) {
                    if (message.data.rst == 'finish') {
                        let store = (<any>window).CdvPurchase.store;
                        store.update()
                            .then(async _ => {
                                let myProduct = store.get(message.data.pid, (<any>window).CdvPurchase.Platform.APPLE_APPSTORE);
                                const myTransaction = store.findInLocalReceipts(myProduct);
                                console.log('terry iOS purchase finish: ', JSON.stringify(myTransaction));
                                if (myTransaction) {
                                    // let receipts = (<any>window).CdvPurchase.store.getAdapter((<any>window).CdvPurchase.Platform.APPLE_APPSTORE).receipts;
                                    // let receipt = receipts[0].nativeData.appStoreReceipt;
                                    let _transactionId = myTransaction.transactionId;
                                    // return { receipt, _transactionId };
                                    return  _transactionId;
                                } else {
                                    this.hideLoading();
                                    return Promise.reject();
                                }
                            })
                            .then((_transactionId) => {
                                if (_transactionId) {
                                    // console.error('terry order result: ', JSON.stringify(receipt));

                                    const receiptData =
                                    {
                                        password: '753444cc5ae24190a355f1149dc890cf',
                                        // 'receipt-data': receipt,
                                        'transactionId': _transactionId
                                    };
                                    let action = 'create';
                                    if (this.userPlan !== PlanName.freePlan) {
                                        action = 'update';
                                    }
                                    let productId = message.data.pid;
                                    const productInfo = {
                                        productId,
                                        receiptData,
                                        action
                                    };
                                    return Promise.resolve(productInfo);
                                } else {
                                    this.hideLoading();
                                    return Promise.reject();
                                }
                            },
                                err => {
                                    this.hideLoading();
                                    return Promise.reject();
                                })
                            .then(productInfo => {
                                if (productInfo) {
                                    this.planName = productInfo.productId;
                                    this.finishPurchases = true;
                                    this.snackBar.open('Updating your license, please wait.', 'OK', { verticalPosition: 'bottom' });
                                    return (this.billService as IOSBillService)
                                        .saveReceiptInDdb(productInfo.productId, productInfo.receiptData, productInfo.action);
                                } else {
                                    this.hideLoading();
                                    return Promise.reject();
                                }
                            },
                                err => {
                                    this.hideLoading();
                                    return Promise.reject();
                                })
                            .then(() => {
                                this.isWaitingForLicense = true;
                                this.messageService.sendMessage({ name: MessageCognitoInit });
                                return Promise.resolve();
                            },
                                err => {
                                    this.hideLoading();
                                    return Promise.reject();
                                })
                            .catch(error => {
                                console.error('terry catch error: ', error.message);
                                this.hideLoading();
                            });
                    } else if (message.data.rst == 'error' || message.data.rst == 'cancel' || message.data.rst == 'refunded') {
                        this.hideLoading();
                    }
                }
            }
        });

    }


    checkLicenseMatchAndroidTransaction(transactionId) {
        let matchId = '';
        if (this.userPlan == PlanName.premPlan) {
            if (this.isMonthly) {
                matchId = 'prem_monthly';
            } else {
                matchId = 'prem_yearly';
            }
        } else if(this.userPlan == PlanName.plusPlan) {
            if (this.isMonthly) {
                matchId = 'plus_monthly';
            } else {
                matchId = 'plus_yearly';
            }
        }
        if (matchId == transactionId) {
            return true;
        } else {
            return false;
        }
    }

    ngOnInit() {
        if (AppService.isPW()) {
            this.calculateProrate();
        }
        if (AppService.isAndroid() || AppService.isIOS()) {
            this.messageService.sendMessage({ name: MessageCheckTokenHasExpired });
        }
        // if (AppService.isAndroid()) {
        //     // this.initAndroidStore();
        // }
        // let license = JSON.parse(localStorage.getItem('pw-license'));
        // if (license !== null && license.planName !== null) {
        //     if (license.planName === 'Premium Plan') {
        //         localStorage.setItem('NaCordovaPremPaid', 'yes');
        //         localStorage.setItem('NaCordovaPlusPaid', 'no');
        //     } else if (license.planName === 'Plus Plan') {
        //         localStorage.setItem('NaCordovaPremPaid', 'no');
        //         localStorage.setItem('NaCordovaPlusPaid', 'yes');
        //     } else {
        //         localStorage.setItem('NaCordovaPremPaid', 'no');
        //         localStorage.setItem('NaCordovaPlusPaid', 'no');
        //     }
        // } else {
        //     localStorage.setItem('NaCordovaPremPaid', 'no');
        //     localStorage.setItem('NaCordovaPlusPaid', 'no');
        // }

        // this.premPaid = localStorage.getItem('NaCordovaPremPaid') == 'yes' ? true : false;
        // this.plusPaid = localStorage.getItem('NaCordovaPlusPaid') == 'yes' ? true : false;

        // this.userPlan = this.userService.getuserPlan();
        if (AppService.isIOS() || AppService.isAndroid()) {
            let store = (<any>window).CdvPurchase.store;
            store.update()
            .then(async _ => {
                store.products.forEach((p) => {
                    // alert(p.id);
                    // alert(p.offers[0].pricingPhases[0].price);
                    let pricingPhase = p.offers[0].pricingPhases[0];
                    // alert(p.id + " == " + JSON.stringify(pricingPhase));
                    if(p.id == 'Plus_Monthly' || p.id == 'plus_monthly') {
                        this.plusMonthlyPrice.price = pricingPhase.price;
                        this.plusMonthlyPrice.priceMicros = pricingPhase.priceMicros;
                        this.plusMonthlyPrice.averagePrice = parseFloat((pricingPhase.priceMicros / 1000000).toFixed(2));
                        this.plusMonthlyPrice.currency = pricingPhase.currency;
                    } else if(p.id == 'Yearly_Plus_Plan' || p.id == 'plus_yearly') {
                        this.plusYearlyPrice.price = pricingPhase.price;
                        this.plusYearlyPrice.priceMicros = pricingPhase.priceMicros;
                        this.plusYearlyPrice.averagePrice = parseFloat((pricingPhase.priceMicros / 1000000 / 12).toFixed(2));
                        this.plusYearlyPrice.currency = pricingPhase.currency;
                    }
                });
            });
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    ngAfterViewInit() {
        this.isUpgrade = this.data.isUpgrade;
        if (this.isUpgrade) {
            this.dialogTitle = 'Upgrade';
        } else {
            this.dialogTitle = 'Downgrade';
        }
        this.userPlan = this.data.userPlan;
        if (AppService.isAndroid() || AppService.isIOS()) {
            this.changeChoosePlan(false);
        } else {
            this.changeChoosePlan(this.data.isMonthly);
        }

    }

    calculateProrate() {
        let licCodeNew = '6005';
        if (this.liccode === '6006') {
            licCodeNew = '6008';
        }
        const alertConfig = new MatDialogConfig();
        alertConfig.backdropClass = 'pw-dialog-backdrop';
        alertConfig.panelClass = 'pw-alert-dialog';
        alertConfig.autoFocus = false;
        this.billService.calculateProrate(this.email, this.liccode, licCodeNew)
            .then(resp => {
                console.log(resp.resp);
                this.prorate = (resp.resp / 100).toFixed(2);
            }).catch(err => {
                this.dialogRef.close();
                let text = 'Something went wrong, please try again.';
                if (err === 'ERR_SUB_NOT_FOUND') {
                    text = 'Looks like you don\'t have an active Premium subscription. ' +
                        'Please check to see if you have an active subscription or ' +
                        'have previously upgraded to Plus.';
                }
                alertConfig.data = {
                    type: 'old',
                    title: '',
                    text,
                    data: null,
                    button_left: null,
                    button_center: 'OK',
                    button_right: null
                };
                this.dialog.open(PwAlertDialogComponent, alertConfig);
            });
        return 0;
    }

    upgrade(): any {
        const alertConfig = new MatDialogConfig();
        alertConfig.backdropClass = 'pw-dialog-backdrop';
        alertConfig.panelClass = 'pw-alert-dialog';
        alertConfig.autoFocus = false;
        console.log(this.liccode);
        let licCodeNew = '6005';
        if (this.liccode === '6006') {
            licCodeNew = '6008';
        }
        // $('.processing').show();
        // $('.upgrade-buttons').prop('disabled', true);
        this.isUpgradingOnStripe = true;
        this.billService.upgradeUserAccount(this.email, this.liccode, licCodeNew)
            .then(resp => {
                this.dialogRef.close();
                this.isUpgradingOnStripe = false;
                alertConfig.data = {
                    type: 'old',
                    title: '',
                    text: 'You have successfully been upgraded to the Plus plan!',
                    data: null,
                    button_left: null,
                    button_center: null,
                    button_right: 'OK'
                };
                this.dialog.open(PwAlertDialogComponent, alertConfig);
            }).catch(err => {
                this.dialogRef.close();
                this.isUpgradingOnStripe = false;
                console.log('Something went wrong: ', err);
                let text = 'Something went wrong, please try again.';
                if (err === 'ERR_SUB_NOT_FOUND') {
                    text = 'Looks like you don\'t have an active Premium subscription. ' +
                        'Please check to see if you already have Plus or an active subscription';
                } else if (err === 'ERR_NO_VALID_SRC') {
                    text = 'Looks like you don\'t have an active payment method attached to your account. ' +
                        'Please update your card information and try again.';
                } else if (err === 'ERR_PAYMENT_FAILED') {
                    text = 'There was an issue while charging payment. If the error persists, please update ' +
                        'your card information and try again.';
                }
                alertConfig.data = {
                    type: 'old',
                    title: '',
                    text,
                    data: null,
                    button_left: null,
                    button_center: 'OK',
                    button_right: null
                };
                this.dialog.open(PwAlertDialogComponent, alertConfig);
            });
    }

    goToDemoPage(): any {
        if (AppService.isIOS() || AppService.isAndroid()) {
            location.href = 'https://www.naturalreaders.com/plusvoicedemo.html';
        } else {
            // location.href = '../plusvoicedemo.html';
            window.open('../plusvoicedemo.html', '_blank');
        }
    }

    buy(type): any {
        // type: "prem_monthly", "plus_monthly", "prem_yearly", "plus_yearly"
        if (this.email === '' || this.email === 'user@naturalreaders.com') {
            this.snackBar.open("You have to log in or create an account first.", "OK", { politeness: 'assertive', duration: 2000, verticalPosition: 'bottom' });
            return;
        }
        this.paidType = type;
        let productId = '';
        // let isProd = environment.production? '': '_Test'; // for test subscriptionIds
        let isProd = '';
        if (type === 'prem_monthly') {
            if (AppService.isIOS()) {
                productId = "Personal_Premium_Monthly" + isProd;
            } else if (AppService.isAndroid()) {
                productId = "prem_monthly";
            }
        } else if (type === 'prem_yearly') {
            if (AppService.isIOS()) {
                productId = "Yearly_Premium_Plan" + isProd;
            } else if (AppService.isAndroid()) {
                productId = "prem_yearly";
            }
        } else if (type === 'plus_monthly') {
            if (AppService.isIOS()) {
                productId = "Plus_Monthly" + isProd;
            } else if (AppService.isAndroid()) {
                productId = "plus_monthly";
            }
        } else if (type === 'plus_yearly') {
            if (AppService.isIOS()) {
                productId = "Yearly_Plus_Plan" + isProd;
            } else if (AppService.isAndroid()) {
                productId = "plus_yearly";
            }
        }
    
        let productIds = ["Personal_Premium_Monthly" + isProd, "Plus_Monthly" + isProd, "Yearly_Premium_Plan" + isProd, "Yearly_Plus_Plan" + isProd];
        if (AppService.isAndroid()) {
            productIds = ["prem_monthly", "plus_monthly", "prem_yearly", "plus_yearly"];
        }

        this.showLoading();
        if (AppService.isIOS()) {
        // if(false) {
            let store = (<any>window).CdvPurchase.store;
            store.update()
            .then(_ => {
                store.get(productId).getOffer().order()
                    .then((result) => {
                        if (result && result.isError) {
                            if (result.code === (<any>window).CdvPurchase.ErrorCode.PAYMENT_CANCELLED) {
                              // Payment cancelled: window closed by user
                              console.log('terry buy(): cancelled');
                              this.messageService.sendMessage({ name: MessageCordovaAppStore, data: { 'rst': 'cancel' } });
                            } else {
                              // Payment failed: check result.message
                              console.log('terry buy(): failed');
                              this.messageService.sendMessage({ name: MessageCordovaAppStore, data: { 'rst': 'error' } });
                            }
                          } else {
                            // Success
                            console.log('terry buy(): success' + JSON.stringify(result));
                            this.messageService.sendMessage({ name: MessageCordovaAppStore, data: { 'rst': 'finish', 'pid': productId} });
                          }

                        // let receipts = null;
                        // receipts = (<any>window).CdvPurchase.store.getAdapter((<any>window).CdvPurchase.Platform.APPLE_APPSTORE).receipts;
                        // let receipt = receipts[0].nativeData.appStoreReceipt;
                        // alert('terry order result: ' + JSON.stringify(result));
                        // const receiptData =
                        // {
                        //     password: '753444cc5ae24190a355f1149dc890cf',
                        //     'receipt-data': receipt
                        //     // 'transactionId': data.transactionId
                        // };
                        // let action = 'create';
                        // if (this.userPlan !== PlanName.freePlan) {
                        //     action = 'update';
                        // }

                        // const productInfo = {
                        //     productId,
                        //     receiptData,
                        //     action
                        // };
                        // this.planName = productInfo.productId;
                        // this.finishPurchases = true;
                        // this.snackBar.open('Updating your license, please wait.', 'OK', { verticalPosition: 'bottom' });
                        // // this.snackBar.open('Updating your license, please wait.', 'OK');
                        // (this.billService as IOSBillService)
                        //         .saveReceiptInDdb(productInfo.productId, productInfo.receiptData, productInfo.action);
                        // this.isWaitingForLicense = true;
                        // this.messageService.sendMessage({ name: MessageCognitoInit });
                        // if (result && result.isError) {
                        //     // if (result.code === (<any>window).CdvPurchase.ErrorCode.PAYMENT_CANCELLED) {
                        //     //     this.messageService.sendMessage({ name: MessageCordovaAndroidStore, data: { 'rst': 'cancel' } });
                        //     // } else {
                        //     //     this.messageService.sendMessage({ name: MessageCordovaAndroidStore, data: { 'rst': 'error' } });
                        //     // }
                        // } else {
                        // }
                    },
                    err => {
                        this.hideLoading();
                        return Promise.reject();
                    }
                );
            }).catch(function(err) {
                console.log(err);
                this.hideLoading();
                return Promise.reject();
            });
        } else {
            // Android IAP
            // ["prem_monthly", "plus_monthly", "prem_yearly", "plus_yearly"];
            // if (((type == 'prem_monthly' || type == 'prem_yearly') && this.premPaid) || ((type == 'plus_monthly' || type == 'plus_yearly') && this.plusPaid)) {
            //     alert('You have owned this product.');
            //     this.hideLoading();
            //     return;
            // }

            // let store = (<any>window).store;
            let store = (<any>window).CdvPurchase.store;

            store.update()
            .then(async _ => {
                if (store.products.length == 0) {
                    const _storeAlertText = 'Please confirm whether you have logged in your account on the Google Play Store app. If you have already logged in, the version of the Play Store app on your device may be too low to support the feature, please follow the steps and try again. \n' + 
                    '1. Update the latest version of Play Store app. \n' + 
                    '2. Restart NaturalReader app. \n';
                    alert(_storeAlertText);
                    this.hideLoading();
                    return;
                }
                // const _support = store.checkSupport((<any>window).CdvPurchase.Platform.GOOGLE_PLAY, "order");
                let receipts = null;
                if(AppService.isIOS()) {
                    receipts = (<any>window).CdvPurchase.store.getAdapter((<any>window).CdvPurchase.Platform.APPLE_APPSTORE).receipts;
                } else {
                    receipts = (<any>window).CdvPurchase.store.getAdapter((<any>window).CdvPurchase.Platform.GOOGLE_PLAY).receipts;
                }
                let buyProduct = null;
                let _oldPurchaseToken = null;
                let _oldPurchaseId = null;

                if (receipts && receipts.length > 0) {
                    _oldPurchaseToken = receipts[receipts.length-1].purchaseToken;
                    _oldPurchaseId = receipts[receipts.length-1].transactions[0].nativePurchase.productId;
                    await (<AndroidBillService>this.billService).androidReceiptVerify(_oldPurchaseId, _oldPurchaseToken)
                    .then(res => {
                        },
                        err => {
                            _oldPurchaseToken = null;
                            _oldPurchaseId = null;
                        }
                    )
                    .catch(() => {
                        _oldPurchaseToken = null;
                        _oldPurchaseId = null;
                    });
                }
                // console.error('terry receipts: ' + JSON.stringify(receipts));
                // console.error('terry purchaseToken: ' + _oldPurchaseToken);
                // let _oldPurchaseToken = this.settingsService.transactionPurchaseToken;
                // let _oldPurchaseId = this.settingsService.transactionPurchaseId;
                if (store.get(type).owned && _oldPurchaseId === type) {
                    alert('You have owned this product.');
                    this.hideLoading();
                    return;
                }
                for (let p of store.products) {
                    if (p.id == productId) {
                        buyProduct = p;
                        break;
                    }
                }
                if (buyProduct && buyProduct.canPurchase) {
                    if (!_oldPurchaseToken) {
                        // console.error('terry buy:');
                        store.get(productId).getOffer().order()
                        .then((result) => {
                            // console.error('terry order(): ' + JSON.stringify(result));
                            if (result && result.isError) {
                              if (result.code === (<any>window).CdvPurchase.ErrorCode.PAYMENT_CANCELLED) {
                                // Payment cancelled: window closed by user
                                // console.error('terry buy(): cancelled');
                                this.messageService.sendMessage({ name: MessageCordovaAndroidStore, data: { 'rst': 'cancel' } });
                              } else {
                                // Payment failed: check result.message
                                // console.error('terry buy(): failed');
                                this.messageService.sendMessage({ name: MessageCordovaAndroidStore, data: { 'rst': 'error' } });
                              }
                            } else {
                              // Success
                            //   console.error('terry buy(): success' + JSON.stringify(result));
                            }
                          });
                    } else {
                        // console.error('terry upgrade:');
                        store.order(store.get(productId).getOffer(), {
                            googlePlay: {
                                oldPurchaseToken: _oldPurchaseToken,
                                prorationMode: (<any>window).CdvPurchase.GooglePlay.ProrationMode.IMMEDIATE_AND_CHARGE_PRORATED_PRICE,
                            }
                        })
                        .then((result) => {
                            // console.error('terry order() with oldPurchaseToken: ' + JSON.stringify(result));
                            if (result && result.isError) {
                                if (result.code === (<any>window).CdvPurchase.ErrorCode.PAYMENT_CANCELLED) {
                                    // Payment cancelled: window closed by user
                                    // console.error('terry buy(): cancelled');
                                    this.messageService.sendMessage({ name: MessageCordovaAndroidStore, data: { 'rst': 'cancel' } });
                                } else {
                                    // Payment failed: check result.message
                                    // console.error('terry buy(): failed');
                                    this.messageService.sendMessage({ name: MessageCordovaAndroidStore, data: { 'rst': 'error' } });
                                }
                            } else {
                                    // Success
                                    //   console.error('terry buy(): success' + JSON.stringify(result));
                            }
                        });
                    }
                } else {
                    store.manageSubscriptions();
                }
            });
        }
    }

    login(): any {
        if (AppService.isIOS()) {
            window.location.replace('login-service/index.html?redir=ios');
        } else if (AppService.isAndroid()) {
            window.location.replace('login-service/index.html?redir=android');
        }
    }

    createAccount(): any {
        if (AppService.isIOS()) {
            window.location.replace('login-service/index.html?redir=ios&jumpto=signup');
        } else if (AppService.isAndroid()) {
            window.location.replace('login-service/index.html?redir=android&jumpto=signup');
        }
    }

    private showLoading(): any {
        this.showLoad = true;
        return new Promise((resolve) => {
            this.messageService.sendMessage({ name: MessageCordovaIAPProcessing, data: { state: true } });
            resolve(null);
        });
    }

    private hideLoading(): any {
        this.showLoad = false;
        this.finishPurchases = false;
        return new Promise((resolve) => {
            this.messageService.sendMessage({ name: MessageCordovaIAPProcessing, data: { state: false } });
            resolve(null);
        });
    }

    close() {
        this.isWaitingForLicense = false;
        this.hideLoading();
        this.dialog.closeAll();
    }

    cancelLoading() {
        this.isWaitingForLicense = false;
        this.hideLoading();
    }

    clickRestore() {
        this.lazyLoadingService.loadAppInitialModule()
            .then(_ => {
                this.messageService.sendMessage({ name: MessageCordovaRestore });
            });
    }


    /* add for new payment UI */
    changePlan() {
        this.isBestPlan = !this.isBestPlan;
    }

    changeBackdrop(open: boolean) {
        this.backdropOpen = open;
    }

    closePayment() {
        this.dialog.closeAll();
    }

    restoreLicenseClick() {
        this.lazyLoadingService.loadAppInitialModule()
            .then(_ => {
                if (AppService.isIOS() || AppService.isAndroid()) {
                    this.messageService.sendMessage({ name: MessageCordovaRestore });
                } else {
                    this.messageService.sendMessage({ name: MessageRestoreLicense });
                }
            });
    }
    /* add for new payment UI */

    openCompare() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.maxWidth = "100%";
        dialogConfig.panelClass = ['pw-compare-dialog', "pw-full-handset"]
        return this.dialog.open(CompareComponent, dialogConfig);
    }

    changeChoosePlan(type) {
        this.isMonthly = type;
        if (this.isMonthly) {
            this.selectedPlan = this.monthlyValue;
        } else {
            this.selectedPlan = this.yearlyValue;
        }
    }
}
